type GAEvent = {
  event: string;
  form_id?: string;
  form_name?: string;
  form_success?: boolean;
};

export const trackGA = ({
  event,
  form_id = 'contact-form',
  form_name = 'Contact Form',
  form_success,
}: GAEvent) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event,
      form_id,
      form_name,
      ...(form_success !== undefined && { form_success }),
    });
  }
};
